import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useDeviceType from "../../hook/useDeviceType";
import { useNavigate } from "react-router";
import { IoMdClose } from "react-icons/io";
import { GoScreenFull } from "react-icons/go";
import { BiExitFullscreen, BiFullscreen } from "react-icons/bi";
import GameBoxHeader from "./components/gameBoxHeader";
import VipBar from "./components/vipBar";
import { COMMON_WEB_PATH } from "../../constant";
import GameCatalog from "../../components/GameCatalog";
import { closeFullScreen } from "../../redux/action/game/gameAction";
import UserClickGameCatalog from "../../components/UserClickGameCatalog";
import { getRandomSlice } from "../../utils/shuffle";

const GameWrap = ({ children }) => {
  const gameList = useSelector((state) => state.isGameList);
  const gameLink = useSelector((state) => state.isGameLink);
  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);
  const isVipBarOpen = useSelector((state) => state.isVipBar);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const gameConfig = useSelector((state) => state.isGameConfig);

  const { randomlySelectedGames, topGameList } = isHandleAllGame;

  const topGameRandom = useMemo(() => {
    return getRandomSlice(topGameList);
  }, [gameConfig]);

  const dispatch = useDispatch();

  const deviceType = useDeviceType();

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [gameLink]);

  useEffect(() => {
    dispatch(closeFullScreen());
  }, []);

  return deviceType === "PC" ? (
    <>
      <section
        className={`pt-[20px] ${
          isOpenFullScreen && "fixed top-0 left-0 w-full  h-full z-[1000] !pt-0"
        }`}
      >
        <section
          className={`${isOpenFullScreen || "lg:w-[1128px] h-[588px]"} ${
            isVipBarOpen && "lg:w-full"
          } flex mx-auto rounded-[5px] overflow-hidden`}
        >
          <section
            className={`${isVipBarOpen ? "w-[calc(100%-280px)]" : "w-full"}`}
          >
            <GameBoxHeader />
            {children}
          </section>
          {isVipBarOpen && (
            <section
              className={`w-[280px] bg-base-white dark:bg-base-dark md:overflow-y-scroll no-scrollbar`}
            >
              <VipBar />
            </section>
          )}
        </section>
        <div className="p-[10px]">
          {/* <UserClickGameCatalog /> */}
          <GameCatalog
            wrapperClassName={`!my-0`}
            list={topGameRandom}
            mainTitle={`Top`}
            swiperProps={{
              customPerView: "game-box-layout",
            }}
          />
        </div>
      </section>
    </>
  ) : (
    children
  );
};

export default GameWrap;
